<template>
  <back-office-form
    :inputs="inputs"
    :item="casino"
    :delete-button-label="this.$t('casinos.delete')"
    delete-confirmation-attribute="name"
    :mode="mode"
    :modes="modes"
    @submit="handleSubmit"
    @delete="handleDelete"
  />
</template>

<script>
  import IntegrationSelect from './IntegrationSelect'
  import JurisdictionSelect from './JurisdictionSelect'
  import AdapterSelect from './AdapterSelect'
  import CasinoOptionsConfiguration from './CasinoOptionsConfiguration'
  import BackOfficeForm from '@/components/BackOfficeForm'
  import CasinoIntegrationOptions from '@/components/CasinoIntegrationOptions'

  export default {
    name: 'CasinoForm',
    components: { BackOfficeForm },
    props: {
      casino: {
        type: Object,
        default: () => {
          return {}
        }
      },
      mode: {
        type: String,
        required: true
      }
    },
    methods: {
      handleSubmit (...rest) {
        if(rest[0].jurisdiction.hasOwnProperty('key')){
          rest[0].jurisdiction = {id: rest[0].jurisdiction.id};
        }
        this.$emit('submit', ...rest)
      },
      handleDelete () {
        this.$emit('delete')
      }
    },
    computed: {
      modes () {
        return {
          create: {
            title: 'casinos.add',
            subtitles: ['casinos.addDescription']
          },
          edit: {
            title: 'casinos.edit',
            subtitles: ['']
          }
        }
      },
      inputs () {
        return [
          {
            name: 'name',
            validators: 'required',
            properties: {
              placeholder: this.$t('casinos.newCasinoPlaceholder'),
              label: this.$t('common.name'),
            }
          },
          {
            name: 'casinoId',
            validators: 'required',
            properties: {
              placeholder: this.$t('casinos.idPlaceholder'),
              label: this.$t('casinos.id')
            }
          },
          {
            name: 'jurisdiction',
            is: JurisdictionSelect,
            validators: 'required',
            properties: {
              placeholder: this.$t('casinos.jurisdictionKey'),
              label: this.$t('casinos.jurisdictionKey')
            }
          },
          {
            name: 'maxRTP',
            validators: 'min_value:1',
            properties: {
              label: this.$t('casinos.maxRTP'),
              help: this.$t('casinos.maxRTPHelp')
            }
          },
          {
            name: 'integrationId',
            is: IntegrationSelect,
            validators: 'required',
            properties: {
              placeholder: this.$t('common.integration'),
              label: this.$t('common.integration')
            }
          },
          {
            name: 'adapter',
            is: AdapterSelect,
            properties: {
              placeholder: this.$t('common.adapter'),
              label: this.$t('common.adapter'),
            }
          },
          {
            name: 'options',
            is: CasinoOptionsConfiguration,
          },
          {
            name: 'integrationOptionIds',
            is: CasinoIntegrationOptions
          },
        ]
      }
    }
  }
</script>

<style scoped>
</style>
